import React from "react";

function Footer() {
    return (
        <footer className="Footer">
            <a className="FooterLink" href="https://chain.link/">Built with Chainlink</a>
        </footer>
    );
}

export default Footer;